import { BorderStyle, BorderThickness, DynamicCssModel } from "../../../models/DynamicCssModel";
import { alphaByPercentage, foregroundColor } from "../../../theme/Mixins";

export function generateTableHeaderColors(
    dynamicCss: DynamicCssModel,
    theme: object,
): {
    bgColor: string;
    color: string;
} {
    const bgColor = alphaByPercentage(
        theme[dynamicCss.TableHeaderFillColor],
        dynamicCss.TableHeaderFillColorPercent,
    );

    const color = foregroundColor(theme, bgColor);

    return {
        bgColor,
        color,
    };
}

export function getBorder(theme: object, dynamicCss: DynamicCssModel) {
    return `${
        dynamicCss.TableHeaderBorderThickness === BorderThickness.BoldSolid ? "3px" : "1px"
    } solid ${alphaByPercentage(
        theme[dynamicCss.TableHeaderBorderColor],
        dynamicCss.TableHeaderBorderColorPercent,
    )} !important`;
}

export function createCssForGridHeader(theme: object, dynamicCss: DynamicCssModel): string {
    let css = "";
    if (dynamicCss.TableRowBorderStyle === BorderStyle.All) {
        return css;
    }

    const border = getBorder(theme, dynamicCss);
    if (BorderStyle.All === dynamicCss.TableHeaderBorderStyle) {
        css += `.grid-view tr:not(.data-row) { border: ${border}; }`;
    }

    if (BorderStyle.Outside === dynamicCss.TableHeaderBorderStyle) {
        css += `
            .grid-view tr:not(.data-row) { border-left: ${border}; border-right: ${border}; }
            .grid-view tr:not(.data-row):first-child  { border-top: ${border}; }
            /* To apply the border bottom effect on last header */
            .grid-view .header-row + .data-row { border-top: ${border}; } 
        `;
    }

    if (BorderStyle.Vertical === dynamicCss.TableHeaderBorderStyle) {
        css += `.grid-view tr:not(.data-row) td:not(:last-child), .grid-view tr:not(.data-row) th:not(:last-child) { 
            border: none;
            border-right: ${border};   
        }`;
    }

    if (BorderStyle.Horizontal === dynamicCss.TableHeaderBorderStyle) {
        css += `.grid-view tr:not(.data-row):not(:last-child) { border-bottom: ${border}; }`;
    }

    if (BorderStyle.All === dynamicCss.TableHeaderBorderStyle) {
        css += `.grid-view tr:not(.data-row) th, .grid-view tr:not(.data-row) td { 
            border-left: ${border}; 
        }`;
    }

    return css;
}

export function createCssForGridHeaderBackground(bgColor: string, color: string) {
    return `
        .grid-view tr.header-row, .grid-view tr:not(.data-row) {
            background-color: ${bgColor} !important;
            color: ${color} !important;
        }
        .grid-view th, .grid-view td { background-color:transparent !important;}
    `;
}
